import styled from 'styled-components';
import { select, withQuery } from '@panel/commons/core/themev2';
import checkCircularBlack from '@panel/commons/assets/icons/checkCircularBlack.svg';

const BannerContainer = styled.div`
  background-color: #f8f9f5;
  padding: 44px 44px 44px 50px !important;
  max-width: 650px !important!;
  display: flex;
  flex-direction: column;
  white-space: normal;
  margin-top: 25px;
  > div {
    :nth-of-type(2),
    :nth-of-type(3),
    :nth-of-type(4) {
      margin-bottom: 24px;
    }
    :nth-of-type(5) {
      margin-bottom: 48px;
    }
  }

  ${withQuery.lg.down()} {
    align-items: flex-start;
  }
  ${withQuery.xs.down()} {
    max-width: 360px;
    padding: 45px 20px;
  }
`;

const BannerLogo = styled.div`
  > img {
    :nth-of-type(1) {
      margin-right: 10px;
    }
  }
`;

const BannerTitle = styled.h2`
  font-family: 'Oatmeal Pro 2 regular';
  font-size: 35px;
  color: ${select('black')};
  line-height: 35px;
  margin-top: 42px;
  max-width: 422px;
  ${withQuery.lg.down()} {
    text-align: left;
  }
`;

const BannerText = styled.p`
  font-family: 'Oatmeal Pro 2 regular';
  font-size: 15px;
  font-weight: 400;
  margin-top: 8px;
  color: ${select('black')};
  line-height: 1.3;
  margin-bottom: 43px;
  ${withQuery.xs.down()} {
    text-align: left;
  }
`;

const BannerBenefitsDetail = styled.span`
  font-family: 'Oatmeal Pro 2 regular';
  font-style: normal;
  font-size: 15px;
  color: ${select('black')};
  font-weight: 400;
  white-space: normal;
  line-height: 24px;
  display: inline-block;
  height: 48px;
  max-width: 347px;
  ${withQuery.lg.down()} {
    text-align: left;
  }
  ${withQuery.xs.down()} {
    width: 272px;
  }
`;

const BannerBenefitsCheck = styled.span`
  width: 22px;
  height: 22px;
  background-image: url(${checkCircularBlack});
  background-repeat: no-repeat;
  margin-right: 8px;
  display: inline-block;
  vertical-align: top;
  position: relative;
`;

const BannerButton = styled.button`
  text-decoration: none;
  width: 246px;
  font-family: 'Oatmeal Pro 2 regular';
  background: ${select('blueBenvi')};
  color: ${select('white')};
  font-size: 15px;
  padding: 12px 24px;
  border-radius: 0;
  cursor: pointer;
  ${withQuery.lg.up()} {
    margin-right: 24px;
  }
  ${withQuery.lg.down()} {
    display: block;
  }
  ${withQuery.xs.down()} {
    width: 100%;
  }
`;

export {
  BannerContainer,
  BannerLogo,
  BannerTitle,
  BannerText,
  BannerBenefitsDetail,
  BannerBenefitsCheck,
  BannerButton
};
